import React from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';

import * as ST from './styled';


const options = [
    '1.Один из быстрорастущих операторов России. Компания работает в 40 регионах России.',
    '2.Дом.ру запустил совместный проект с «МегаФоном» и вышел на рынок сотовой связи в 32 городах.',
    '3. В Дом.ру самый большой выбор HD-каналов среди федеральных провайдеров. Клиентам цифрового телевидения доступно 84 HD-канала.',
    '4. Дом.ру создал тариф, который можно настроить под себя. «Конструктор» позволяет самостоятельно выбирать каналы и скорость интернета.',
    '5. В Москве запущена городская Wi-Fi сеть</span> из 1100 точек доступа внутри Садового кольца.',
    '6. Дом.ру предоставляет услугу «Кабельное телевидение» и «Домашний телефон» по выгодной стоимости и с дополнительными сервисами.',
];

interface IDescriptions {
    request: (url: string) => void,
}

const Descriptions = ({ request }: IDescriptions) => {
    return (
        <ST.Promo>
            <ST.Title>Дом.ру — это</ST.Title>
            <ST.Container>
                <ST.List>
                    {options.map((item, index) => (
                        <ST.Text key={index}>{item}</ST.Text>
                    ))}
                </ST.List>
            </ST.Container>
            <Button onClick={() => request('request')}>Подключить Дом.ру</Button>
        </ST.Promo>
    );
};

export default Descriptions;
